import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=3be7a70c&scoped=true"
import script from "./RoleManage.vue?vue&type=script&lang=ts"
export * from "./RoleManage.vue?vue&type=script&lang=ts"
import style0 from "./RoleManage.vue?vue&type=style&index=0&id=3be7a70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7a70c",
  null
  
)

export default component.exports